/* eslint react/no-danger: "off" */
import PropTypes from 'prop-types'
import React from 'react'
import showdown from 'showdown'
import DOMPurify from 'dompurify'

const converter = new showdown.Converter({ openLinksInNewWindow: true })

const contentConverter = (markdown) => converter.makeHtml(markdown)

const MarkdownRenderer = ({ children }) => {
  if (!children) {
    return null
  }

  return (
    <span
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(contentConverter(children || '')) }}
    />
  )
}

MarkdownRenderer.propTypes = { children: PropTypes.string.isRequired }

export default MarkdownRenderer
